import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import useActions from "@/hooks/useActions"
import useLayout from "hooks/useLayout"
import Form from "components/forms/form"
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import Button from "components/inputs/button"
import ButtonGroup from "components/buttons/buttonGroup"
import Section from "components/layout/section"

interface DeleteActionFormProps {
    storageId: string
    productId: string
    actionId: string
    transactionDocId?: string
}

const DeleteActionForm: React.FC<DeleteActionFormProps> = ({ storageId, productId, actionId, transactionDocId }) => {
    const { t } = useTranslation()
    const { deleteProductActionAsync } = useActions({ storageId, productId })
    const { closeDialog, addToast } = useLayout()

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        closeDialog()
        void deleteProductActionAsync({ storageId, productId, actionId, transactionDocId }).catch(() => {
            addToast({ text: t('toastActionDeleteError'), colorScheme: 'red' })
        })
    }

    if (!storageId) return <Callout type={'error'}>{t('storageIdMissing')}</Callout>
    if (!productId) return <Callout type={'error'}>{t('productId')}</Callout>
    if (!actionId) return <Callout type={'error'}>{t('ACTION_NOT_FOUND')}</Callout>

    return (
        <Form
            onSubmit={handleSubmit}
            className={`group`}
        >
            <Section>
                <p>{t('deleteActionConfirmation')}</p>
                <ButtonGroup>
                    <Button wideOnMobile type="button" design="optional" onClick={closeDialog}><CloseIcon /><span>{t('buttonCancel')}</span></Button>
                    <Button wideOnMobile type="submit" design="danger"><DeleteIcon /><span>{t('delete')}</span></Button>
                </ButtonGroup>
            </Section>
        </Form>
    )
}

export default DeleteActionForm
